import React from 'react';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  size?: 'sm' | 'md'; // sm=28x16, md=36x20
  trackOn?: string;
  trackOff?: string;
  disabled?: boolean;
}

export function Toggle({
  checked,
  onChange,
  size = 'md',
  trackOn = '#159662',
  trackOff = '#DC2626',
  disabled = false,
}: ToggleProps) {
  const w = size === 'sm' ? 28 : 36;
  const h = size === 'sm' ? 16 : 20;
  const knob = size === 'sm' ? 12 : 16;
  const travel = w - h; // knob travel distance

  return (
    <button
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => !disabled && onChange(!checked)}
      className="relative flex-shrink-0 rounded-toggle transition-colors focus:outline-none"
      style={{
        width: w,
        height: h,
        background: checked ? trackOn : trackOff,
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
        padding: (h - knob) / 2,
      }}
    >
      <span
        className="block rounded-full bg-white shadow-sm"
        style={{
          width: knob,
          height: knob,
          transform: checked ? `translateX(${travel}px)` : 'translateX(0)',
          transition: 'transform 0.2s',
        }}
      />
    </button>
  );
}

// AI / Manual labeled toggle
interface AiToggleProps {
  aiActive: boolean;
  onChange: (ai: boolean) => void;
  disabled?: boolean;
}

export function AiToggle({ aiActive, onChange, disabled }: AiToggleProps) {
  return (
    <div className="flex items-center gap-2">
      <span
        className="text-[11px] font-medium"
        style={{
          fontFamily: '"DM Mono", monospace',
          color: aiActive ? '#159662' : '#DC2626',
          minWidth: 50,
        }}
      >
        {aiActive ? 'AI' : 'MANUAL'}
      </span>
      <Toggle
        checked={aiActive}
        onChange={onChange}
        size="md"
        trackOn="#159662"
        trackOff="#DC2626"
        disabled={disabled}
      />
    </div>
  );
}
